import React from "react";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { useLanguage } from "../contexts/LanguageContext";
import { navigateToPremiumPurchase } from "../utils/subscriptionQrFlow";
import { PremiumLinkedText } from "./premium/PremiumFeatures";

const PremiumLockedBanner = ({
  title,
  description,
  showUpgrade = false,
  compact = false,
  className = "",
  qrId,
  variant = "renew",
}) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const isRenew = variant === "renew";

  return (
    <div
      className={`rounded-lg border border-border bg-muted/50 text-muted-foreground ${
        compact ? "p-4" : "p-6"
      } ${className}`}
    >
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-md bg-muted flex items-center justify-center shrink-0">
          <Lock size={18} strokeWidth={1.75} className="text-muted-foreground" aria-hidden />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`font-semibold text-foreground ${compact ? "text-body" : "text-body"}`}>
            <PremiumLinkedText text={title || t("premium.lockedTitle")} />
          </p>
          <p className={`mt-2 text-muted-foreground ${compact ? "text-caption" : "text-body"}`}>
            <PremiumLinkedText text={description || t("premium.lockedDesc")} />
          </p>
          {showUpgrade && (
            <Button
              type="button"
              size="sm"
              className="mt-3"
              onClick={() => navigateToPremiumPurchase(navigate, { qrId, variant })}
            >
              {isRenew ? t("premium.upgradeCta") : t("premium.buyCta")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PremiumLockedBanner;
